import { LOCAL_STORAGE_TTL } from "../shared/constants";

interface StorageItem<T> {
    value: T;
    timestamp: number;
}

export const LocalStorageService = {
    getItem: <T>(key: string): T | null => {
        try {
            const item = localStorage.getItem(key);
            if (!item) return null;

            const storedItem: StorageItem<T> = JSON.parse(item);

            if (Date.now() > storedItem.timestamp + LOCAL_STORAGE_TTL * 1000) {
                localStorage.removeItem(key);
                return null;
            }

            return storedItem.value;
        } catch (error) {
            console.error('Error removing from localStorage:', error);
            return null;
        }
    },

    setItem: <T>(key: string, value: T): void => {
        try {
            const item: StorageItem<T> = {
                value,
                timestamp: Date.now(),
            };
            localStorage.setItem(key, JSON.stringify(item));
        } catch (error) {
            console.error('Error saving to localStorage:', error);
        }
    },

};